<template>
	<div class="store-info-body">
		<div class="store-info-container">
			<div class="title-box">
				<img class="title-img" src="~/images/icon/express.png">
				<span style="font-size: 13px;font-weight: 400;color: #333;">卖家配送</span>
			</div>
			<div class="switch-box">
				是否启用
				<el-switch
					:disabled='editDisable'
					@change="freightChange"
					v-model="freightflag"
					active-color="var(--fx-primary-color)"
					inactive-color="#E9EAEB"
					:active-value="1"
					:inactive-value="0">
				</el-switch>
				<span class="link-span" @click="goFreight">运费管理</span>
			</div>
			<div class="line"></div>
			<div class="title-box">
				<img class="title-img" src="~/images/icon/self-collection.png">
				<span style="font-size: 13px;font-weight: 400;color: #333333;">买家自提</span>
			</div>
			<div class="switch-box">
				是否启用
				<el-switch
					:disabled='editDisable'
					@change="selfpickflagChange('1')"
					v-model="selfpickflag"
					active-color="var(--fx-primary-color)"
					inactive-color="#E9EAEB"
					:active-value="1"
					:inactive-value="0">
				</el-switch>
				<span class="link-span" @click="goSelfDelivery">自提点管理</span>
			</div>
			<div class="switch-box" v-if="selfpickflag === 1">
				自提点：
				<el-radio-group v-model="allSelfPickFlag" @change="selfpickflagChange('2')">
					<el-radio :label="1" :disabled='editDisable'>同集团（全部）</el-radio>
					<el-radio :label="0" :disabled='editDisable'>自定义</el-radio>
				</el-radio-group>
			</div>
			<div v-if="allSelfPickFlag === 0 && selfpickflag === 1" class="table-box">
				<div class="table-title">
					<div>
						<el-button size="mini" plain type="primary" @click="addClick" v-if='!editDisable'>关联自提点</el-button>
						<el-button size="mini" plain type="primary" @click="delMuti" v-if='!editDisable'>批量删除</el-button>
					</div>
					<div>
						省：
						<el-select v-model="province" class="name-input" size='mini' clearable @change='provinceChange()' placeholder="请选择">
							<el-option
								v-for="item in provinceList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
						市：
						<el-select v-model="city" class="name-input" size='mini' clearable @change='cityChange()' placeholder="请选择">
							<el-option
								v-for="item in cityList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
						区：
						<el-select v-model="district" class="name-input" clearable size='mini' placeholder="请选择">
							<el-option
								v-for="(item,index) in districtList"
								:key="index"
								:label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
						<el-input placeholder="请输入内容" v-model="key" size="mini" style="width:200px;margin-right:10px">
							<el-button slot="append" class='input-button' icon="el-icon-search" @click="search"></el-button>
						</el-input>
					</div>
				</div>
				<div style="flex:1">
					<el-table
						size='mini'
						class="grid-content"
						ref='table'
						:data="tableData"
						height="100%"
						@selection-change='selectionHandle'
						border>
						<el-table-column
							type="selection"
							align="center"
							width="50">
						</el-table-column>
						<el-table-column
							prop="selfPickName"
							label="自提点名称"
							align="center"
							min-width="120">
						</el-table-column>
						<el-table-column
							prop="selfPickAddress"
							label="详细地址"
							align="center"
							min-width="120">
						</el-table-column>
						<el-table-column
							prop="selfPickLinkName"
							label="联系人"
							align="center"
							min-width="100">
						</el-table-column>
						<el-table-column
							prop="selfPickTel"
							label="联系电话"
							align="center"
							min-width="120">
						</el-table-column>
						<el-table-column
							prop="selfPickMoney"
							label="自提费用"
							align="center"
							min-width="120">
						</el-table-column>
						<el-table-column
							label="自提时间"
							align="center"
							min-width="200">
							<template slot-scope="scope">
								<div style="display:flex;flex-direction:column">
									<!-- {{scope.row.selfPickTimes[0].beginDate}}1111 -->
									<div style="text-align:left" v-for="item in scope.row.selfPickTimes" :key="item.id">
										{{item.beginDate}} - {{item.endDate}} ({{item.selfPickDate}})
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column v-if='!editDisable' label="操作" width="180" align="center">
							<template slot-scope="scope">
								<el-button size="mini" type='text' icon="el-icon-delete" @click="deleteClick(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-pagination
					style="margin-top:5px;text-align:right;margin-right:10px"
					@size-change="handleSizeChange"
					@current-change="handlePageChange"
					:current-page="page.num"
					:page-sizes="[20, 40, 60, 100, 300]"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
			<div class="switch-box">
				是否启用临时自提点
				<el-switch
					:disabled='editDisable'
					@change="shortSelfPickFlagChange"
					v-model="shortSelfPickFlag"
					active-color="var(--fx-primary-color)"
					inactive-color="#E9EAEB"
					:active-value="1"
					:inactive-value="0">
				</el-switch>
			</div>
		</div>
		<el-dialog
			top='100px'
			title="关联自提点"
			class="dialog-title"
			:visible.sync="addmodel"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindModel v-if="addmodel" :chooseData1='chooseData' :shopId='shopid' @reloadCus='reloadData' :customerDialog.sync='addmodel'></bindModel>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { cityData } from '@/js/location/city.js'
import { provinceData } from '@/js/location/province.js'
import { geography } from '@/js/location/geography.js'
import { areaData } from '@/js/location/areaData.js'
import bindModel from '@/components/storeSetting/bindShop.vue'
export default {
	name: 'deliveryWay',
	components: {
		bindModel
	},
	data () {
		return {
			chooseData: [],
			addmodel: false,
			page: {
				size: 20,
				num: 1
			},
			total: null,
			tableData: [],
			key: '',
			editDisable: true,
			shopid: '',
			freightflag: 0,
			selfpickflag: 0,
			allSelfPickFlag: 1,
			shortSelfPickFlag: 0,
			freightflagFix: 0,
			selfpickflagFix: 0,
			shortSelfPickFlagFix: 0,
			province: '',
			city: '',
			district: '',
			provinceList: [],
			cityList: [],
			districtList: [],
			provinceListTotal: [],
			ids: [],
			areaList: []
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '2-2')
		this.getAuthority('01_0001_0000_00')
	},
	mounted () {
		this.shopid = sessionStorage.getItem('storeid')
		this.provinceListTotal = provinceData.RECORDS
		this.provinceList = provinceData.RECORDS
		this.areaList = geography
		this.getDetail()
	},
	methods: {
		goFreight () {
			this.$router.push('/main/freight')
		},
		goSelfDelivery () {
			this.$router.push('/main/selfDelivery')
		},
		reloadData () {
			this.addmodel = false
			this.getDetail()
		},
		addClick () {
			this.addmodel = true
		},
		delMuti () {
			if (this.ids.length === 0) {
				this.$message.error('请选择自提点')
				return false
			}
			let params = {
				shopId: this.shopid,
				ids: this.ids
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/delRelShopSelfPick`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.getDetail()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		deleteClick (data) {
			let params = {
				shopId: this.shopid,
				ids: [data.id]
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/delRelShopSelfPick`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.getDetail()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (val) {
			this.page.num = 1
			this.page.size = val
			this.search()
		},
		handlePageChange (val) {
			this.page.num = val
			this.search()
		},
		selectionHandle (data) {
			this.ids = data.map(item => {
				return item.id
			})
		},
		getAll () {
			let params = {
				shopId: this.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/getShopSelfPickInfo`,
				data: params
			}).then(res => {
				if (res.recordList === null) {
					this.chooseData = []
					return false
				}
				this.chooseData = res.recordList.map(item => {
					return item.id
				})
			})
		},
		search () {
			let params = {
				shopId: this.shopid,
				province: this.province,
				city: this.city,
				district: this.district,
				page: this.page.num,
				size: this.page.size,
				key: this.key
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/getShopSelfPickInfo`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.total = res.recordCount
			})
		},
		provinceChange () {
			this.cityList = []
			this.districtList = []
			this.city = ''
			this.district = ''
			let a = cityData.RECORDS
			for (let i = 0; i < a.length; i++) {
				if (this.province === a[i].pid) {
					this.cityList.push(a[i])
				}
			}
		},
		cityChange () {
			let province = this.province
			let city = this.city
			this.districtList = []
			this.district = ''
			for (let i = 0; i < areaData.length; i++) {
				if (province === areaData[i].code) {
					for (let j = 0; j < areaData[i].child.length; j++) {
						if (city === areaData[i].child[j].code) {
							this.districtList = areaData[i].child[j].child
						}
					}
				}
			}
		},
		areaChange (e) {
			this.city = ''
			this.province = ''
			this.district = ''
			this.provinceList = []
			this.cityList = []
			this.districtList = []
			if (e === '0') {
				this.provinceList = this.provinceListTotal
			} else {
				let a = this.provinceListTotal
				for (let i = 0; i < a.length; i++) {
					if (a[i].areacode === this.area) {
						this.provinceList.push(a[i])
					}
				}
			}
		},
		selfpickflagChange (type) {
			let params = {
				shopid: this.shopid,
				selfpickflag: this.selfpickflag,
				allSelfPickFlag: this.allSelfPickFlag
			}
			if (type === '1') {
				let pre = this.selfpickflagFix === 1 ? '是' : '否'
				let cur = this.selfpickflag === 1 ? '是' : '否'
				let msg = `是否启用买家自提由${pre}修改为${cur}`
				let url = window.location.href.split('?')[0]
				url = url.replace(window.location.origin, '').substring(1)
				params.logMessage = {
					message: msg,
					referer: url
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/saveSelfPickFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.getDetail()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		freightChange () {
			let pre = this.freightflagFix === 1 ? '是' : '否'
			let cur = this.freightflag === 1 ? '是' : '否'
			let msg = `是否启用卖家配送由${pre}修改为${cur}`
			let url = window.location.href.split('?')[0]
			url = url.replace(window.location.origin, '').substring(1)
			let params = {
				shopid: this.shopid,
				freightflag: this.freightflag,
				logMessage: {
					message: msg,
					referer: url
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/saveFreightFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.getDetail()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		shortSelfPickFlagChange () {
			let pre = this.shortSelfPickFlagFix === 1 ? '是' : '否'
			let cur = this.shortSelfPickFlag === 1 ? '是' : '否'
			let msg = `是否启用临时自提点由${pre}修改为${cur}`
			let url = window.location.href.split('?')[0]
			url = url.replace(window.location.origin, '').substring(1)
			let params = {
				shopid: this.shopid,
				shortSelfPickFlag: this.shortSelfPickFlag,
				logMessage: {
					message: msg,
					referer: url
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/saveShortSelfPickFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.getDetail()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			let isAdd = window.sessionStorage.getItem('isAdd') === 'true'
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					a.forEach(item => {
						if (item === '01_0001_0001_00' && !isAdd) {
							this.editDisable = false
						}
						if (item === '01_0001_0002_00' && isAdd) {
							this.editDisable = false
						}
					})
				}
			})
		},
		getDetail () {
			let params = {
				shopId: this.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/getShopDistribution`,
				data: params
			}).then(res => {
				if (res.result) {
					this.selfpickflag = res.data.selfPickFlag
					this.freightflag = res.data.freightFlag
					this.allSelfPickFlag = res.data.allSelfPickFlag
					this.shortSelfPickFlag = res.data.shortSelfPickFlag
					this.freightflagFix = this.$fxUtils.deepClone(res.data.freightFlag)
					this.selfpickflagFix = this.$fxUtils.deepClone(res.data.selfPickFlag)
					this.shortSelfPickFlagFix = this.$fxUtils.deepClone(res.data.shortSelfPickFlag)
					if (this.selfpickflag === 1 && this.allSelfPickFlag !== 1) {
						this.getAll()
						this.search()
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-info-body {
	display flex;
	height: 100%;
	min-height: 0;
	flex: 1;
	flex-direction column
	/deep/.el-form-item.is-success .el-input__inner {
		border-color: #DCDFE6
	}
	.store-info-container {
		display flex;
		flex: 1;
		overflow-y: auto;
		flex-direction column;
		padding :5 10px;
		.title-box {
			display :flex;
			flex-direction :row;
			height :36px;
			align-items :center
			.title-img{
				width:24px;
				height:18px;
				margin-right :5px
			}
		}
		.switch-box{
			display :flex;
			flex-direction :row;
			height :40px;
			align-items :center;
			.el-switch{
				margin :0 10px;
			}
		}
		.link-span{
			cursor: pointer;
			font-size: 12px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			text-decoration: underline;
			color: var(--fx-primary-color);
		}
		.line {
			margin: 10px 0;
			width :100%;
			height :1px;
			background-color :#EEEEEE
		}
		.table-box{
			flex:1;
			display :flex;
			flex-direction :column;
		}
		.table-title{
			display :flex;
			flex-direction :row;
			align-items :center;
			justify-content :space-between;
			height :40px;
		}
		.name-input{
			margin-right :10px;
		}
		.input-button{
			background-color:var(--fx-primary-color);
			color:#ffffff;
			width:16px;
			height:28px;
			display:flex;
			align-items :center;
			justify-content :center;
		}
	}
}
</style>
